import equipmentPageActions from './equipmentPageActions';
import { getTimeZone } from '../../helpers/getTimeZone';
import { getOptions } from 'helpers/getOptions';

import $api from 'http/index';

const EQUIPMENT_PER_PAGE = 40;

export const fetchEquipmentData =
  (filters = {}, page = 0, searchValue = null, forceUpdate = false) =>
  async (dispatch, getState) => {
    const {hasMore} = getState().equipment;

    if (!hasMore && !forceUpdate) return;

    const options = {
      ...getOptions(),
      params: {
        skip: page * EQUIPMENT_PER_PAGE,
        limit: EQUIPMENT_PER_PAGE,
      },
    };
    if (filters && Object.keys(filters).length) {
      if (filters.sortBy) options.params.sortBy = filters.sortBy;
      if (filters.sortOrder) options.params.sortOrder = filters.sortOrder;
      if (filters.companyWide) options.params.companyWide = true;
    }

    if (searchValue) options.params.searchValue = searchValue;

    // dispatch(equipmentPageActions.contractorsRequest(true))

    try {
      const response = await $api.get(`${process.env.REACT_APP_BASE_URL}/equipment`, options);

      if (page === 0) {
        dispatch(
          equipmentPageActions.getEquipmentData({
            data: response.data,
            hasMore: response.data.length === EQUIPMENT_PER_PAGE,
          })
        );
      } else {
        dispatch(
          equipmentPageActions.getEquipmentDataAdd({
            data: response.data,
            hasMore: response.data.length === EQUIPMENT_PER_PAGE,
          })
        );
      }
    } catch (error) {
      dispatch(equipmentPageActions.equipmentError());
    }
  };

export const fetchAllEquipmentData =
  (filters = {}, searchValue = null) =>
  async (dispatch) => {
    const options = {
      ...getOptions(),
      params: {},
    };

    if (filters && Object.keys(filters).length) {
      if (filters.sortBy) options.params.sortBy = filters.sortBy;
      if (filters.sortOrder) options.params.sortOrder = filters.sortOrder;
      if (filters.companyWide) options.params.companyWide = true;
    }

    if (searchValue) options.params.searchValue = searchValue;

    try {
      const response = await $api.get(`${process.env.REACT_APP_BASE_URL}/equipment`, options);
      dispatch(
        equipmentPageActions.getEquipmentData({
          data: response.data,
          hasMore: false,
        })
      );
    } catch (error) {
      dispatch(equipmentPageActions.equipmentError());
    }
  };



export const fetchDeleteEquipment = (equipmentId) => async (dispatch) => {

  try {
    await $api.delete(`${process.env.REACT_APP_BASE_URL}/equipment/${equipmentId}
    `, getOptions());
    dispatch(equipmentPageActions.deleteEquipment(equipmentId));
  } catch (error) {
    dispatch(equipmentPageActions.equipmentError(error));
  }
};

export const postCreateEquipment = (data) => async (dispatch) => {

    const res = await $api.post(`${process.env.REACT_APP_BASE_URL}/equipment`, data, getOptions());
    dispatch(equipmentPageActions.createNewEquipment(res.data));
};

export const putUpdateEquipment = (data, equipmentId) => async (dispatch) => {

    const res = await $api.put(`${process.env.REACT_APP_BASE_URL}/equipment/${equipmentId}`, data, getOptions());
    dispatch(equipmentPageActions.updateEquipment(res.data));
};
